import { IAction } from '../utils';
import { reducerTypes } from './types';

export interface ILanguageReducer {
  selectedLanguage: string;
  languages: { id: string; label: string }[];
}

export const INITIAL: ILanguageReducer = {
  selectedLanguage: typeof window !== 'undefined' ? window?.localStorage?.getItem('selected-lang') || 'EN' : 'EN',
  languages: [
    { id: 'EN', label: 'EN' },
    { id: 'CZ', label: 'CZ' },
  ],
};

export const selectedLangReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.SET_SELECTED_LANGUAGE:
      if (typeof window !== 'undefined') localStorage.setItem('selected-lang', payload);
      return { ...state, selectedLanguage: payload };
    default:
      return state;
  }
};
